import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { TitleService } from '../../services/title.service';
import { CartItem } from '../../model/cartItem';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { RouterLink } from '@angular/router';
import { ImgSrcSetDirective } from '../../directives/img-src-set.directive';
import { RingSizeSelectorComponent } from '../ring-size-selector/ring-size-selector.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shopping-cart',
    templateUrl: './shopping-cart.component.html',
    styleUrls: ['./shopping-cart.component.scss'],
    imports: [BreadCrumbComponent, RouterLink, ImgSrcSetDirective, RingSizeSelectorComponent, AsyncPipe]
})
export class ShoppingCartComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);
  shoppingCartService = inject(ShoppingCartService);


  ngOnInit() {
    const title = 'Shopping Cart';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }

  removeFromCart(cartItem: CartItem): void {
    this.shoppingCartService.removeFromCart(cartItem);
  }

}
